import { getConfig } from '@edx/frontend-platform';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}// RG theme: keep the light/dark choice in sync between the legacy (server-rendered)
// LMS/Studio pages and the MFEs, across tabs and origins.
//
// Two stores are involved:
//   * legacy pages persist the choice in the cross-origin `theme-variant` cookie
//     (scoped to the shared parent domain, e.g. ".local.openedx.io");
//   * the MFEs render light/dark via Paragon theme variants, and @edx/frontend-platform
//     reads the active variant from localStorage['selected-paragon-theme-variant'] at
//     init (key: SELECTED_THEME_VARIANT_KEY), reflecting it on <html data-paragon-theme-variant>.
//
// This bridge ties the two together (same idea as tutor-indigo, adapted to Paragon
// variants instead of a body class). It is plain top-level module code in env.config,
// so it runs once when the module is imported — before frontend-platform reads the
// variant — which lets us seed localStorage without a page reload.
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') { return; }

  var COOKIE_NAME = 'theme-variant';                 // legacy cross-origin cookie
  var LS_KEY = 'selected-paragon-theme-variant';     // frontend-platform's variant store
  var HTML_ATTR = 'data-paragon-theme-variant';      // attribute frontend-platform sets

  function isVariant(v) { return v === 'dark' || v === 'light'; }

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  // 1) legacy -> MFE: adopt the cookie variant *before* frontend-platform reads
  //    localStorage, so the MFE renders the same variant the user picked on a legacy page.
  try {
    var cookieVariant = readCookie(COOKIE_NAME);
    if (isVariant(cookieVariant) && window.localStorage.getItem(LS_KEY) !== cookieVariant) {
      window.localStorage.setItem(LS_KEY, cookieVariant);
    }
  } catch (e) { /* localStorage unavailable (private mode / blocked) */ }

  // 2) MFE -> legacy: when frontend-platform changes the active variant (e.g. via the
  //    Paragon theme toggle in the MFE header) it updates <html data-paragon-theme-variant>.
  //    Mirror that into the shared cookie so legacy pages and other origins follow.
  function cookieDomain() {
    try {
      var d = getConfig().THEME_COOKIE_DOMAIN;
      if (d) { return d; }
    } catch (e) { /* getConfig not populated yet / not imported */ }
    // Fallback: the MFE host is `apps.<LMS_HOST>`, so the shared parent is the host
    // minus its first label (e.g. apps.local.openedx.io -> .local.openedx.io).
    return '.' + window.location.hostname.replace(/^[^.]+\./, '');
  }

  function mirrorVariantToCookie() {
    var variant = document.documentElement.getAttribute(HTML_ATTR);
    if (!isVariant(variant) || readCookie(COOKIE_NAME) === variant) { return; }
    document.cookie = COOKIE_NAME + '=' + variant + '; path=/; domain=' + cookieDomain()
      + '; max-age=31536000; samesite=lax'
      + (window.location.protocol === 'https:' ? '; secure' : '');
  }

  try {
    // Attach before React renders so the very first variant frontend-platform applies
    // is mirrored too.
    new MutationObserver(mirrorVariantToCookie).observe(document.documentElement, {
      attributes: true,
      attributeFilter: [HTML_ATTR],
    });
  } catch (e) { /* MutationObserver unavailable */ }
})();

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'account') {
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
    }
    if (process.env.APP_ID == 'learner-record') {
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;